<template>
  <div>
    <p class="message colorGrey mb5 notranslate">{{locale.reservation_message_touchmove}}</p>
    <div ref="map" class="mapFrame">
      <div class="seatMap">
        <div class="ground">
          <!-- object:: top -->
          <div v-if="objects && objects.top && objects.top.length" class="objects top">
            <SeatRect v-for="(obj, index) in objects.top"
              :key="`top_${obj.object}_${index}`"
              :w="obj.w"
              :h="obj.h"
              :x="obj.x"
              :y="obj.y">
              <span class="obj" :data-obj="obj.object"></span>
            </SeatRect>
          </div>
          <!-- //object:: top -->
          <!-- object:: bottom -->
          <div v-if="objects && objects.bottom && objects.bottom.length" class="objects bottom">
            <SeatRect v-for="(obj, index) in objects.bottom"
              :key="`bottom_${obj.object}_${index}`"
              :w="obj.w"
              :h="obj.h"
              :x="obj.x"
              :y="obj.y">
              <span class="obj" :data-obj="obj.object"></span>
            </SeatRect>
          </div>
          <!-- //object:: bottom -->
          <!-- object:: left -->
          <div v-if="objects && objects.left && objects.left.length" class="objects left">
            <SeatRect v-for="(obj, index) in objects.left"
              :key="`left_${obj.object}_${index}`"
              :w="obj.w"
              :h="obj.h"
              :x="obj.x"
              :y="obj.y">
              <span class="obj" :data-obj="obj.object"></span>
            </SeatRect>
          </div>
          <!-- //object:: left -->
          <!-- object:: right -->
          <div v-if="objects && objects.right && objects.right.length" class="objects right">
            <SeatRect v-for="(obj, index) in objects.right"
              :key="`right_${obj.object}_${index}`"
              :w="obj.w"
              :h="obj.h"
              :x="obj.x"
              :y="obj.y">
              <span class="obj" :data-obj="obj.object"></span>
            </SeatRect>
          </div>
          <!-- //object:: right -->
          <!-- seat map -->
          <div class="seatsBg">
            <div id="seats" class="seats" ref="seat">
              <SeatRect v-for="seat in seats"
                :key="seat.seatId"
                :data-place="seat.placeId"
                :data-seat="seat.seatId"
                :data-active="!seat.disabled && activeTarget.includes(seat.seatId)"
                :data-disabled="seat.disabled"
                :w="seat.w"
                :h="seat.h"
                :x="seat.x"
                :y="seat.y">
                <div class="filler"
                  :class="{disabled: seat.disabled}"
                  @click="active(seat)">
                  <span v-if="info.showPlaceName" class="place" :style="{backgroundColor: seat.color}">
                    {{seat.placeName[lang]}}
                  </span>
                  <span v-if="info.showSeatName" class="seat">{{seat.name[lang]}}</span>
                </div>
              </SeatRect>
            </div>
          </div>
          <!-- //seat map -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeatRect from '@/components/Reservation/SeatRect.vue'

export default {
  name: 'SeatMap',
  props: [
    'locale',
    'lang',
    'seats',
    'objects',
    'info',
    'activeTarget',
    'count'
  ],
  components: {
    SeatRect
  },
  computed: {
    seatList () {
      const seats = this.seats
      const list = seats.map
    }
  },
  methods: {
    active (seat) {
      const disabled = seat.disabled
      if (!disabled) {
        this.$emit('activeSeat', {
          placeId: seat.placeId,
          placeName: seat.placeName,
          seatId: seat.seatId,
          seatName: seat.name
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mapFrame {
  overflow: auto;
}
.ground:before {
  // content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.message {
  font-size: 14px;
  &:before {
    content: "";
    display: inline-block;
    position: relative;
    top: 2px;
    width: 20px;
    height: 16px;
    margin-right: 4px;
    background: url('~@/assets/img/ico_touchmove_horizontal.png') 0 50% / contain no-repeat;
    opacity: 0.5;
  }
}
</style>
